import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';
import { adminFetch } from '../../utils/adminApi';
import SeoFieldsForm from './SeoFieldsForm';
import SectionBuilder from './SectionBuilder';
import './AdminSeoPanels.css';

const PAGE_LABELS = {
  home: 'Homepage',
  'about-us': 'About Us',
  'contact-us': 'Contact Us',
  'warranty-policy': 'Warranty Policy',
  custom: 'Custom Page',
};

const PagesCmsPanel = () => {
  const [pages, setPages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    const res = await adminFetch('/api/pages');
    if (res.ok) setPages(await res.json());
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!selected) return;
    setLoading(true);
    const res = await adminFetch(`/api/pages/${selected._id}`, { method: 'PUT', body: JSON.stringify(selected) });
    setLoading(false);
    if (res.ok) {
      Swal.fire('Saved', `${PAGE_LABELS[selected.pageKey] || selected.title} updated.`, 'success');
      load();
    } else Swal.fire('Error', 'Could not save page.', 'error');
  };

  return (
    <div className="admin-seo-panel animate-in">
      <h2 className="admin-seo-panel-title">Pages CMS</h2>
      <p className="admin-seo-panel-desc">Edit Homepage, About, Contact and Warranty content + SEO. Enable &quot;CMS Pages&quot; in Technical SEO when ready.</p>

      <section className="admin-seo-section">
        <h3>Select Page</h3>
        <div className="form-row one-col">
          <label>Page
            <select
              value={selected?._id || ''}
              onChange={(e) => setSelected(pages.find((p) => p._id === e.target.value) || null)}
            >
              <option value="">Choose a page...</option>
              {pages.map((p) => (
                <option key={p._id} value={p._id}>{PAGE_LABELS[p.pageKey] || p.pageKey} — {p.title}</option>
              ))}
            </select>
          </label>
        </div>
      </section>

      {selected && (
        <>
          <section className="admin-seo-section">
            <h3>{PAGE_LABELS[selected.pageKey] || selected.title}</h3>
            <div className="form-row">
              <label>Title
                <input value={selected.title || ''} onChange={(e) => setSelected({ ...selected, title: e.target.value })} />
              </label>
              <label>Status
                <select value={selected.status || 'published'} onChange={(e) => setSelected({ ...selected, status: e.target.value })}>
                  <option value="published">Published</option>
                  <option value="draft">Draft</option>
                </select>
              </label>
            </div>
            <h3 className="admin-seo-subtitle" style={{ marginTop: 8 }}>Sections</h3>
            <SectionBuilder sections={selected.sections || []} onChange={(sections) => setSelected({ ...selected, sections })} />
          </section>

          <SeoFieldsForm title="Page SEO" values={selected} onChange={(seo) => setSelected({ ...selected, ...seo })} />

          <div className="admin-seo-actions">
            <button type="button" className="action-submit-btn" onClick={save} disabled={loading}>Save Page</button>
          </div>
        </>
      )}
    </div>
  );
};

export default PagesCmsPanel;
